/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-translate/src/translate.pipe';
import * as import2 from 'ng2-translate/src/translate.service';
import * as import3 from '../../ui-elements/qr-code/qr-code-panel/qr-code-panel.component.ngfactory';
import * as import4 from '../../ui-elements/qr-code/qr-code-panel/qr-code-panel.component';
import * as import5 from '../../orchestration/navigation.service';
import * as import6 from '@angular/common';
import * as import7 from './member-card-panel.component';
import * as import8 from '../../orchestration/session.model';
import * as import9 from '../identity.model';
const styles_MemberCardPanelComponent:any[] = ([] as any[]);
export const RenderType_MemberCardPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_MemberCardPanelComponent,
  data: {}
}
);
function View_MemberCardPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'member-contact-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n        ',
      '\n    '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.identityModel.currentMember == null)? (null as any): ((co.identityModel.currentMember.contact == null)? (null as any): co.identityModel.currentMember.contact.email));
    ck(v,1,0,currVal_0);
  });
}
function View_MemberCardPanelComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'member-contact-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n        ',
      '\n    '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.identityModel.currentMember == null)? (null as any): ((co.identityModel.currentMember.contact == null)? (null as any): co.identityModel.currentMember.contact.mobilePhone));
    ck(v,1,0,currVal_0);
  });
}
function View_MemberCardPanelComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'member-number'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'member-number-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      ':\n        '
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'member-number-value'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform('woa.common.memberNumber'));
    ck(v,3,0,currVal_0);
    const currVal_1:any = (((co.identityModel.currentMember == null)? (null as any): co.identityModel.currentMember.integratedLoyaltyId) || ((co.identityModel.currentMember == null)? (null as any): co.identityModel.currentMember.memberNo));
    ck(v,7,0,currVal_1);
  });
}
function View_MemberCardPanelComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),19,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'member-number'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'member-number-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      ':\n            '
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'member-number-value'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'member-code'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-qr-code-panel',([] as any[]),(null as any),(null as any),(null as any),import3.View_QrCodePanelComponent_0,import3.RenderType_QrCodePanelComponent)),
    import0.ɵdid(49152,(null as any),0,import4.QrCodePanelComponent,[import5.NavigationService],{
      value: [
        0,
        'value'
      ]
      ,
      message: [
        1,
        'message'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = (((co.identityModel.currentMember == null)? (null as any): co.identityModel.currentMember.integratedCardNo) || ((co.identityModel.currentMember == null)? (null as any): co.identityModel.currentMember.memberCardNo));
    const currVal_3:any = import0.ɵunv(v,15,1,import0.ɵnov(v,16).transform('woa.label.member.qrCode'));
    ck(v,15,0,currVal_2,currVal_3);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,5,0,import0.ɵnov(v,6).transform('woa.common.memberCardNumber'));
    ck(v,5,0,currVal_0);
    const currVal_1:any = (((co.identityModel.currentMember == null)? (null as any): co.identityModel.currentMember.integratedCardNo) || ((co.identityModel.currentMember == null)? (null as any): co.identityModel.currentMember.memberCardNo));
    ck(v,9,0,currVal_1);
  });
}
function View_MemberCardPanelComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'member-points'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'member-points-balance'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'member-points-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.identityModel.currentMember == null)? (null as any): co.identityModel.currentMember.pointsBalance);
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵunv(v,6,0,import0.ɵnov(v,7).transform('woa.label.member.points'));
    ck(v,6,0,currVal_1);
  });
}
function View_MemberCardPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),23,'div',[[
        'class',
        'member'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showQrCode($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'member-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n        ',
      ' ',
      '\n    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MemberCardPanelComponent_2)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MemberCardPanelComponent_3)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'member-type'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n        ',
      '\n    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MemberCardPanelComponent_4)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MemberCardPanelComponent_5)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_MemberCardPanelComponent_6)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import6.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = (co.identityModel.loginIdentityIsEmail && ((co.identityModel.currentMember == null)? (null as any): ((co.identityModel.currentMember.contact == null)? (null as any): co.identityModel.currentMember.contact.email)));
    ck(v,6,0,currVal_2);
    const currVal_3:any = (co.identityModel.loginIdentityIsEmail && ((co.identityModel.currentMember == null)? (null as any): ((co.identityModel.currentMember.contact == null)? (null as any): co.identityModel.currentMember.contact.mobilePhone)));
    ck(v,9,0,currVal_3);
    const currVal_5:any = (((co.identityModel.currentMember == null)? (null as any): co.identityModel.currentMember.memberNo) && (!((co.identityModel.currentMember == null)? (null as any): co.identityModel.currentMember.integratedLoyaltyId) || co.identityModel.loginIdentityIsMemberNo));
    ck(v,15,0,currVal_5);
    const currVal_6:any = ((((co.identityModel.currentMember == null)? (null as any): co.identityModel.currentMember.memberCardNo) && !((co.identityModel.currentMember == null)? (null as any): co.identityModel.currentMember.integratedLoyaltyId)) || ((co.identityModel.currentMember == null)? (null as any): co.identityModel.currentMember.integratedCardNo));
    ck(v,18,0,currVal_6);
    const currVal_7:any = import0.ɵunv(v,21,0,import0.ɵnov(v,22).transform(co.SessionEvents.currentApp$)).supportsRedemption;
    ck(v,21,0,currVal_7);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.identityModel.currentMember == null)? (null as any): ((co.identityModel.currentMember.contact == null)? (null as any): co.identityModel.currentMember.contact.firstName));
    const currVal_1:any = ((co.identityModel.currentMember == null)? (null as any): ((co.identityModel.currentMember.contact == null)? (null as any): co.identityModel.currentMember.contact.lastName));
    ck(v,3,0,currVal_0,currVal_1);
    const currVal_4:any = ((co.identityModel.currentMember == null)? (null as any): co.identityModel.currentMember.membershipType.name);
    ck(v,12,0,currVal_4);
  });
}
export function View_MemberCardPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MemberCardPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import7.MemberCardPanelComponent = v.component;
    const currVal_0:any = ((co.identityModel.currentMember == null)? (null as any): co.identityModel.currentMember.memberId);
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_MemberCardPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-member-card-panel',([] as any[]),(null as any),(null as any),(null as any),View_MemberCardPanelComponent_0,RenderType_MemberCardPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import7.MemberCardPanelComponent,[
      import8.SessionModel,
      import9.IdentityModel,
      import5.NavigationService,
      import2.TranslateService
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const MemberCardPanelComponentNgFactory:import0.ComponentFactory<import7.MemberCardPanelComponent> = import0.ɵccf('woa-member-card-panel',import7.MemberCardPanelComponent,View_MemberCardPanelComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/identity/member-card-panel/member-card-panel.component.ngfactory.ts